var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box14"},[_c('pageTitle',{attrs:{"title":"常见问题"}}),_c('commomProblem',{attrs:{"problemData":_vm.problemData,"styleData":_vm.styleData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }